/**
 * Exports.constants — costanti e helper estratti da Exports.jsx
 * per ridurne la dimensione (P2 refactoring).
 */
import {
  FileText, FileType2, Briefcase, ListChecks, HardHat,
  GraduationCap, CalendarClock, GitCompare,
} from "lucide-react";

export const DOCUMENT_TYPE_LABELS = {
  dvr_pdf: "DVR completo (PDF)",
  dvr_docx: "DVR modificabile (DOCX)",
  task_extract: "Estratto per mansione",
  improvement_plan: "Piano di miglioramento",
  ppe_register: "Registro DPI",
  training_plan: "Piano di formazione",
  deadlines: "Scadenzario",
  diff_report: "Report di comparazione",
};

export const DOCUMENT_TYPE_ICONS = {
  dvr_pdf: FileText,
  dvr_docx: FileType2,
  task_extract: Briefcase,
  improvement_plan: ListChecks,
  ppe_register: HardHat,
  training_plan: GraduationCap,
  deadlines: CalendarClock,
  diff_report: GitCompare,
};

export const STATUS_VARIANTS = {
  bozza: "bg-amber-50 text-amber-800 border border-amber-200",
  finale: "bg-blue-50 text-blue-900 border border-blue-200",
  archiviato: "bg-slate-100 text-slate-700 border border-slate-200",
};

export function formatBytes(size) {
  if (!size) return "0 B";
  const units = ["B", "KB", "MB", "GB"];
  let value = size;
  let i = 0;
  while (value >= 1024 && i < units.length - 1) { value /= 1024; i += 1; }
  return `${value.toFixed(value >= 10 ? 0 : 1)} ${units[i]}`;
}
